import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
const styles = [{
  name: 'Anime Style',
  color: 'from-pink-500 to-rose-500'
}, {
  name: 'Cyberpunk',
  color: 'from-cyan-500 to-blue-500'
}, {
  name: 'Pixel Art',
  color: 'from-yellow-400 to-orange-500'
}, {
  name: 'Realistic',
  color: 'from-emerald-500 to-green-600'
}, {
  name: 'Fantasy',
  color: 'from-purple-500 to-indigo-600'
}, {
  name: 'Cartoon',
  color: 'from-red-500 to-orange-600'
}];
export function GallerySection() {
  return <section id="gallery" className="py-24 bg-[#0F0F1A]" data-id="element-56">
      <div className="container mx-auto px-4" data-id="element-57">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-58">
          <div data-id="element-59">
            <h2 className="text-3xl md:text-5xl font-bold font-display mb-4" data-id="element-60">
              Hall of{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-400 to-purple-400" data-id="element-61">
                Fame
              </span>
            </h2>
            <p className="text-gray-400 max-w-xl" data-id="element-62">
              Explore our diverse range of art styles. From gritty cyberpunk to
              vibrant anime, we bring any vision to life.
            </p>
          </div>
          <Button variant="outline" rightIcon={<ArrowRight className="w-4 h-4" data-id="element-64" />} data-id="element-63">
            View Full Gallery
          </Button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-65">
          {styles.map((style, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          scale: 1.03,
          y: -5
        }} className="group relative aspect-square rounded-2xl overflow-hidden cursor-pointer" data-id="element-66">
              {/* Placeholder Gradient Background */}
              <div className={`absolute inset-0 bg-gradient-to-br ${style.color} opacity-80 group-hover:opacity-100 transition-opacity`} data-id="element-67" />

              {/* Silhouette Placeholder */}
              <div className="absolute inset-0 flex items-center justify-center opacity-50 group-hover:opacity-70 transition-opacity" data-id="element-68">
                <svg className="w-32 h-32 text-black/20" viewBox="0 0 24 24" fill="currentColor" data-id="element-69">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" data-id="element-70" />
                </svg>
              </div>

              {/* Overlay Content */}
              <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors p-6 flex flex-col justify-end" data-id="element-71">
                <h3 className="text-xl font-bold text-white translate-y-4 group-hover:translate-y-0 transition-transform font-display" data-id="element-72">
                  {style.name}
                </h3>
                <p className="text-white/80 text-sm opacity-0 group-hover:opacity-100 transition-opacity translate-y-4 group-hover:translate-y-0 delay-75" data-id="element-73">
                  View Examples →
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}